import styled, { css } from 'styled-components';

export const SkeletonWrapper = styled.div<{ inline: boolean }>(
    ({ inline }) => css`
        span {
            display: flex;
            flex-direction: ${inline ? 'row' : 'column'};
        }
    `,
);
